import type { ReactNode } from 'react';
import { Flex } from '@radix-ui/themes';
import { Card } from './Card';
import { HeaderItalic } from './HeaderItalic';

/** Card with a red italic section title, as used on profile pages. */
export function SectionCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Card>
      <Flex direction="column" gap="3">
        <HeaderItalic color="red" size="4">
          {title}
        </HeaderItalic>
        {children}
      </Flex>
    </Card>
  );
}
